<template>
  <div class="box">
      <h1>404</h1>
  </div>
</template>

<script>
export default {
  components:{},
  data(){
    return {
    }
  },
  created(){},
  mounted(){},
  watch:{},
  computed:{},
  methods:{
    
  },
}
</script>
<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/views/404/404.vue